import { useState } from "react";
import LoginPage from "./LoginPage";
import DashboardHome from "./DashboardHome";
import FeedbackList from "./FeedbackList";
import CategoryUpload from "./CategoryUpload";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [view, setView] = useState("home");

  if (!loggedIn) {
    return <LoginPage onLogin={() => setLoggedIn(true)} />;
  }

  return (
    <div>
      <nav style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
        <button onClick={() => setView("home")} style={{ marginRight: 10 }}>
          Översikt
        </button>
        <button onClick={() => setView("list")} style={{ marginRight: 10 }}>
          Feedbacklista
        </button>
        <button onClick={() => setView("upload")}>
          Ladda upp kategorier
        </button>
      </nav>
      {view === "home" && <DashboardHome />}
      {view === "list" && <FeedbackList />}
      {view === "upload" && <CategoryUpload />}
    </div>
  );
}

export default App;
